module.exports = __webpack_public_path__ + "static/img/03d7ec59251f4ce4f61cd09428f61110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon2.png
// module id = 4WYL
// module chunks = 1